import React from 'react'

import { ContainerItemAcoes } from './styles'

export const ContainerAcoes: React.FC = ({ children }) => (
  <ContainerItemAcoes>{children}</ContainerItemAcoes>
)
